import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';

// import PerfectScrollbar from 'perfect-scrollbar';

import Swiper, { Pagination, Autoplay } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination, Autoplay]);

// import ImgLazyLoad from './module/img-lazy-load';

document.oncontextmenu = function () {
  return false;
};

class drApp {
  constructor() {}

  DrLoad() {
    $('html, body').scrollTop(0);

    $('.JsLoad').addClass('JsLoad--Done');

    setTimeout(function () {
      $('.Keyvisual').addClass('JsKeyvisual--Done');
      $('.Loader').addClass('JsLoader--Done');
    }, 300);

    setTimeout(function () {
      $('.Keyvisual__logo').addClass('JsKeyvisualLogo--Done');
    }, 1800);

    setTimeout(function () {
      $('.Carousel').addClass('JsCarousel--Done');
      $('.CommonHeader, .AnnotationGuide').addClass('JsCommonHeader--Done');
      $('#stkr').addClass('Jsstkr--Done');
    }, 2800);
  }
  mgdLoad() {
    //   $('body, html').animate({
    //     scrollTop: 0
    //   }, 1);
    //   this.loadCompleteApp = true;
    //   // window.scrollTo(0, 0);
    //   $('.TitleLocation').each(function (index) {
    //     index = index + 1;
    //     $(this).attr('data-id', "TitleLocation-" + index).attr('id', "TitleLocation-" + index);
    //   });
  }
}

class scrollIdApp {
  constructor() {}
  ScrollAddId() {
    $('.TitleLocation').each(function (index) {
      index = index + 1;
      $(this)
        .attr('data-id', 'TitleLocation-' + index)
        .attr('id', 'TitleLocation-' + index);
    });
  }
  ScrollIdAppClick() {
    $('a[href^="#"], button[href^="#"]').click(function () {
      // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
      var adjust = -80;
      // スクロールの速度（ミリ秒）
      var speed = 400;
      // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
      var href = $(this).attr('href');
      // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
      var target = $(href == '#' || href == '' ? 'html' : href);
      // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
      var position = target.offset().top + adjust;
      // スムーススクロール linear（等速） or swing（変速）
      $('body,html').animate({ scrollTop: position }, speed, 'swing');
      return false;
    });
  }
}

let ScrollIdApp = new scrollIdApp();
let DrApp = new drApp();

$(document).ready(function () {
  console.log('v2.0');

  // スライダー
  $('.SliderGallery').slick({
    autoplay: true, // 自動でスクロール
    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
    speed: 5000, // スライドが流れる速度を設定
    cssEase: 'linear', // スライドの流れ方を等速に設定
    slidesToShow: 5, // 表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, // 矢印非表示
    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3, // 画面幅750px以下でスライド3枚表示
        },
      },
    ],
  });

  //マウスカーソル
  // マウスストーカー関連の要素（任意で変更してください）
  const mouseStalker = '#stkr'; // マウスストーカーになる要素を指定
  const mouseTarget = 'a, button'; // リンクなどアクションを付けたい要素を指定
  const mouseStalkerArea = window; // マウスストーカーが機能する要素を指定

  // 処理で使う変数たち
  const stkrSize = parseInt($(mouseStalker).css('width').replace(/px/, ''));
  const stkrPosX = parseInt($(mouseStalker).css('left').replace(/px/, ''));
  //const stkrPosY = parseInt($(mouseStalker).css("top").replace(/px/, ""));
  const cssPosAjust = stkrPosX + stkrSize / 2;
  let scale = 1;

  // 追従用の処理
  $(mouseStalkerArea).hover(function () {
    $(mouseStalkerArea).mousemove(function (e) {
      let x = e.clientX - cssPosAjust;
      let y = e.clientY - cssPosAjust;
      $(mouseStalker).css({
        transform: 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')',
      });
    });
  });

  // リンクホバーの処理
  // $(mouseTarget).hover(function (e) {
  //   scale = 2;
  //   let x = e.clientX - cssPosAjust;
  //   let y = e.clientY - cssPosAjust;
  //   $(mouseStalker).css({
  //     "transform": "translate(" + x + "px," + y + "px) scale(" + scale + ")",
  //   });
  // }, function () {
  //   scale = 1;
  // });
  $(mouseTarget).hover(
    function () {
      $(mouseStalker).addClass('stkr--Hover');
    },
    function () {
      $(mouseStalker).removeClass('stkr--Hover');
    }
  );
});

$(window).on('load', () => {
  ScrollIdApp.ScrollAddId();
  ScrollIdApp.ScrollIdAppClick();
  DrApp.DrLoad();
});
